module.exports = __webpack_public_path__ + "assets/img/36-s.14d4bc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/36-s.jpg
// module id = c4yY
// module chunks = 0